import React from 'react';
import ArrowCircleUp from '../../../Resources/Images/HomeOut/arrowcircleup.webp'

import "./ButtonAnchorTop.css";

const ButtonAnchorTop = ({action}) =>{
    
    return(        
        <div>
            <img width={50} height={50} src={ArrowCircleUp} alt="Banistmo go top" onClick={action} className='ButtonAnchorTop d-block d-md-none'/>
        </div>
    );
};

export default ButtonAnchorTop;